import { baseThemeValues } from 'constants/common';

const labelLgBase = {
  fontFamily: baseThemeValues.inherit,
  fontSize: '14px',
  fontWeight: 500,
};

const labelSmBase = {
  fontFamily: baseThemeValues.inherit,
  fontSize: '12px',
  fontWeight: 500,
};

const componentBase = {
  borderRadius: '6px',
  borderWidth: '1px',
};

export const countryPhoneTheme = {
  lg: {
    disabled: {
      ...componentBase,
      borderColor: 'palette.surface.3',
      label: {
        ...labelLgBase,
        text: 'palette.neutral.40',
      },
    },
    error: {
      ...componentBase,
      borderColor: 'palette.error.60',
      helpText: {
        fontFamily: baseThemeValues.inherit,
        fontSize: '12px',
        fontWeight: 400,
        text: 'palette.error.60',
      },
      label: {
        ...labelLgBase,
        text: 'palette.primary.60',
      },
    },
    focus: {
      ...componentBase,
      borderColor: 'palette.tertiary.50',
      label: {
        ...labelLgBase,
        text: 'palette.tertiary.60',
      },
    },
    hover: {
      ...componentBase,
      borderColor: 'palette.tertiary.50',
      label: {
        ...labelLgBase,
        text: 'palette.tertiary.60',
      },
    },
    inactive: {
      ...componentBase,
      borderColor: 'palette.tertiary.20',
      label: {
        ...labelLgBase,
        text: 'palette.tertiary.60',
      },
    },
    option: {
      countryName: {
        fontFamily: baseThemeValues.inherit,
        fontSize: '16px',
        fontWeight: 400,
        text: 'palette.tertiary.95',
      },
      countryPrefix: {
        fontFamily: baseThemeValues.inherit,
        fontSize: '16px',
        fontWeight: 400,
        text: 'palette.tertiary.95',
      },
    },
  },
  sm: {
    disabled: {
      ...componentBase,
      borderColor: 'palette.surface.3',
      label: {
        ...labelSmBase,
        text: 'palette.neutral.40',
      },
    },
    error: {
      ...componentBase,
      borderColor: 'palette.error.60',
      helpText: {
        fontFamily: baseThemeValues.inherit,
        fontSize: '12px',
        fontWeight: 400,
        text: 'palette.error.60',
      },
      label: {
        ...labelSmBase,
        text: 'palette.primary.60',
      },
    },
    focus: {
      ...componentBase,
      borderColor: 'palette.tertiary.50',
      label: {
        ...labelSmBase,
        text: 'palette.tertiary.60',
      },
    },
    hover: {
      ...componentBase,
      borderColor: 'palette.tertiary.50',
      label: {
        ...labelSmBase,
        text: 'palette.tertiary.60',
      },
    },
    inactive: {
      ...componentBase,
      borderColor: 'palette.tertiary.20',
      label: {
        ...labelSmBase,
        text: 'palette.tertiary.60',
      },
    },
    option: {
      countryName: {
        fontFamily: baseThemeValues.inherit,
        fontSize: '14px',
        fontWeight: 400,
        text: 'palette.tertiary.95',
      },
      countryPrefix: {
        fontFamily: baseThemeValues.inherit,
        fontSize: '14px',
        fontWeight: 400,
        text: 'palette.tertiary.95',
      },
    },
  },
};
